import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import { AppBar, Tabs, Tab, Typography, Box, Paper } from '@material-ui/core';

import { HomeOutlined, FaceOutlined } from '@material-ui/icons';

import useStyles from './styles';

//stylos css
import './styles.css';

import TabAutorizaciones from '../../pages/Autorizaciones';
import Perfil from '../../pages/Perfil';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Typography
      component='div'
      role='tabpanel'
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function Navbar() {
  const classes = useStyles();
  const [indexTab, setIndexTab] = useState(0);

  const handleChange = (event, newIndexTab) => {
    setIndexTab(newIndexTab);
  };

  return (
    <Fragment>
      <AppBar position='fixed' color='default' className={classes.appBar}>
        <Paper square className={classes.root}>
          <Tabs
            value={indexTab}
            onChange={handleChange}
            variant='fullWidth'
            indicatorColor='secondary'
            textColor='secondary'
            aria-label='icon label tabs example'
          >
            <Tab icon={<HomeOutlined />} label='Mis Reservas' />
            <Tab icon={<FaceOutlined />} label='Perfil' />
          </Tabs>
        </Paper>
      </AppBar>
      <TabPanel value={indexTab} index={0}>
        <TabAutorizaciones setIndexTab={setIndexTab} />
      </TabPanel>
      <TabPanel value={indexTab} index={1}>
        <Perfil />
      </TabPanel>
    </Fragment>
  );
}
